import { dropdownIndex } from '../actions/selectYourXIndexActions';

export default {
    brands: [],
    devices: [],
    models: [],
    selectYourXIndex: dropdownIndex.brand,
    selectYourXDropdowns: [
        { isSelectionOpen: false },

        { isSelectionOpen: false },

        { isSelectionOpen: false }
    ],
    selectedBrandId: "",
    selectedDeviceId: "",
    ad: "",
    configPropValues: {},
    finderTypeId: ""
};